module.exports = __webpack_public_path__ + "img/is_ortakligi.8933bdc2.svg";